export default "__VITE_ASSET__CIjH2Nsk__"